import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OpenLayer {
    isOpen: boolean;
    type: string;
}

const initialState: OpenLayer = {
    isOpen: false,
    type: '',
}

export const loginLayerSlice = createSlice({
    name: "loginLayer",
    initialState: initialState,
    reducers: {
        open: (state, action: PayloadAction<string>) => {
            state.isOpen = true;
            state.type = action.payload;
        },
        close: state => {
            state.isOpen = false;
        }
    }
});

export const { open, close } = loginLayerSlice.actions;

export default loginLayerSlice.reducer;